import { useMemo, useState } from 'react';
import { news as newsArticles } from '@/data/mock';

export const useRssFeeds = (_sources = [], options = {}) => {
  const { limit = 10 } = options;

  const items = useMemo(() => {
    return (newsArticles || []).slice(0, limit).map(article => ({
      title: article.title,
      link: `/news/${article.slug || article.id}`,
      pubDate: article.date,
      source: article.category || 'Redspire News',
      description: article.excerpt,
      image: article.heroImage,
    }));
  }, [limit]);

  return { items, loading: false, error: null };
};

export default useRssFeeds;
